import React, { useEffect, useState } from "react";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  listAll,
  deleteObject,
} from "firebase/storage";
import "../firebase/firebase";

function Home() {
  const [data, setData] = useState([]);
  const [imgFile, setImgFile] = useState(null);
  const [existingImgUrl, setExistingImgUrl] = useState(null);
  const [currentImgName, setCurrentImgName] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const storage = getStorage();

  useEffect(() => {
    const storageRef = ref(storage, "coverImages");

    listAll(storageRef)
      .then((res) => {
        const promises = res.items.map((itemRef) => getDownloadURL(itemRef));

        Promise.all(promises)
          .then((urls) => {
            const newData = res.items.map((itemRef, index) => ({
              id: index,
              imgName: itemRef.name,
              imgUrl: urls[index],
            }));
            setData(newData);
          })
          .catch((error) => {
            console.error("Error fetching download URLs: ", error);
          });
      })
      .catch((error) => {
        console.error("Error listing images: ", error);
      });
  }, [storage]);

  const handleFileChange = (e) => {
    setImgFile(e.target.files[0]);
  };

  const handleSaveItem = async (e) => {
    e.preventDefault();
    let imgUrl = existingImgUrl;

    if (imgFile) {
      const storageRef = ref(storage, `coverImages/${imgFile.name}`);
      await uploadBytes(storageRef, imgFile);
      imgUrl = await getDownloadURL(storageRef);
    }

    if (isEdit) {
      const storageRef = ref(storage, `coverImages/${currentImgName}`);
      try {
        await deleteObject(storageRef); // Delete the old image
        setData(
          data.map((item) =>
            item.imgName === currentImgName
              ? { ...item, imgUrl: imgUrl, imgName: imgFile.name }
              : item
          )
        );
      } catch (error) {
        console.error("Error editing image: ", error);
      }
    } else {
      try {
        const storageRef = ref(storage, `coverImages/${imgFile.name}`);
        await uploadBytes(storageRef, imgFile).then(() => {
          getDownloadURL(storageRef).then((url) => {
            setData([...data, { imgName: imgFile.name, imgUrl: url }]);
          });
        });
      } catch (error) {
        console.error("Error uploading image: ", error);
      }
    }

    setImgFile(null);
    setExistingImgUrl(null);
    setIsEdit(false);
    const modal = new window.bootstrap.Modal(
      document.getElementById("itemModal")
    );
    modal.hide();
  };

  const handleDelete = async (imgName) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this product?"
    );

    if (!isConfirmed) {
      return;
    } else {
      const storageRef = ref(storage, `coverImages/${imgName}`);
      try {
        await deleteObject(storageRef);
        setData(data.filter((item) => item.imgName !== imgName));
      } catch (error) {
        console.error("Error deleting image: ", error);
      }
    }
  };

  const handleEdit = (imgName) => {
    const selectedItem = data.find((item) => item.imgName === imgName);
    if (selectedItem) {
      setCurrentImgName(imgName);
      setExistingImgUrl(selectedItem.imgUrl);
      setIsEdit(true);
    }
    const modal = new window.bootstrap.Modal(
      document.getElementById("itemModal")
    );
    modal.show();
  };

  const handleAdd = () => {
    setCurrentImgName("");
    setExistingImgUrl(null);
    setIsEdit(false);
    const modal = new window.bootstrap.Modal(
      document.getElementById("itemModal")
    );
    modal.show();
  };

  return (
    <div className="page-container">
      <h1 className="mt-3">Cover Images</h1>
      <div className="container mt-5">
        <div className="input-group">
          <button
            className="btn add-data-btn"
            type="button"
            onClick={handleAdd}
          >
            Add Item +
          </button>
        </div>

        <table className="table table-striped table-bordered table-hover rounded table-custom">
          <thead>
            <tr>
              <th>#</th>
              <th>Image Name</th>
              <th>Image URL</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.imgName}</td>
                <td>
                  <a
                    href={item.imgUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Image
                  </a>
                </td>
                <td>
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => handleEdit(item.imgName)}
                  >
                    Edit
                  </button>
                </td>
                <td>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(item.imgName)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="itemModal"
        tabIndex="-1"
        aria-labelledby="itemModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="itemModalLabel">
                {isEdit ? "Edit Cover Image" : "Add Cover Image"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <form onSubmit={handleSaveItem}>
              <div className="modal-body">
                {existingImgUrl && (
                  <div className="form-group">
                    <label>Current Image</label>
                    <img
                      src={existingImgUrl}
                      alt="Cover"
                      className="img-fluid mb-3"
                    />
                  </div>
                )}
                <div className="form-group">
                  <label htmlFor="imgFile">Upload New Image</label>
                  <input
                    type="file"
                    className="form-control"
                    id="imgFile"
                    accept="image/*"
                    onChange={handleFileChange}
                    required={!isEdit && !existingImgUrl}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                  disabled={imgFile === null && !isEdit}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={() => setImgFile(null)}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
